function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "25",
  viewBox: "0 0 26 25",
  width: "26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: "42.627%",
  cy: "40.866%",
  gradientTransform: "matrix(0 1 -.94816 0 .814 -.018)",
  r: "69.525%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#fb4203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#a0fa43"
})), /*#__PURE__*/React.createElement("path", {
  d: "M250.54 158.882c-4.349 2.853-9.815 7.118-6.543 13.118 3.271 6 6.972 8.107 11.032 6 4.059-2.107 2.607-7.322 2.607-9.161s2.446-3.734 4.995-3.734c2.548 0 8.76-8.105 4.38-9.105s-7.927-2-11.244-1-.878 1.03-5.227 3.882z",
  fill: "url(#a)",
  fillRule: "evenodd",
  transform: "translate(-243 -154)"
})));